import { fetchAll, fetchFiltered, addGarage, show, edit } from '@/api/garageaccredited'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  garageById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const garage = await show(id)
      commit('setGarageById', garage)
      return garage
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const garages = await fetchAll()
      commit('setAll', garages)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const garages = await fetchFiltered(queriesParams)
      commit('setAll', garages)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addGarage(data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: e.message === 'E_UNIQUE'
          ? t('cpfCnpjAlreadyExist')
          : e
        },
        { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: e.message === 'E_UNIQUE'
          ? t('cpfCnpjAlreadyExist')
          : e
        },
        { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.garageById = null
  },

  setAll (state, garages) {
    state.all = garages
  },

  setGarageById (state, garage) {
    state.garageById = {
      id: garage.id,
      fantasyName: garage.fantasyName,
      socialReason: garage.socialReason,
      cpfCnpj: garage.cpfCnpj,
      cep: garage.cep,
      uf: garage.uf,
      city: garage.city,
      publicPlace: garage.publicPlace,
      neighborhood: garage.neighborhood,
      establishmentNumber: garage.establishmentNumber,
      phone1: garage.phone1,
      phone2: garage.phone2,
      email: garage.email,
      users: garage.users,
      placeService: garage.placeService,
      latitude: garage.latitude,
      longitude: garage.longitude,
      installationValue: garage.installationValue,
      reinstallationValue: garage.reinstallationValue,
      maintanceValue: garage.maintanceValue,
      withdrawalValue: garage.withdrawalValue,
      kmTraveledValue: garage.kmTraveledValue,
      isActive: garage.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
